/**
 * @description 浏览器代理信息
 * @returns {String}
 */
export const browserUserAgent = (): string => navigator.userAgent.toLowerCase()
